module.exports = __webpack_public_path__ + "bf72679ca22e53320beaea090e8bb07d.woff";